// src/components/Loader.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import {FormattedMessage} from "react-intl";

interface LoaderProps {
    open: boolean;
    message?: string;
    timeoutDuration?: number; // durata in millisecondi per attivare il timeout
}

const Loader: React.FC<LoaderProps> = ({
                                           open,
                                           message = "Caricamento in corso...",
                                           timeoutDuration = 10000, // default: 10 secondi
                                       }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [timeoutReached, setTimeoutReached] = useState(false);

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (open) {
            timer = setTimeout(() => {
                setTimeoutReached(true);
            }, timeoutDuration);
        } else {
            setTimeoutReached(false);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [open, timeoutDuration]);

    return (
        <Backdrop
            open={open}
            sx={{
                color: '#fff',
                zIndex: theme.zIndex.drawer + 1,
                display: 'flex',
                flexDirection: 'column',
                transition: 'opacity 0.3s ease-in-out'
            }}
        >
            <CircularProgress color="inherit" />
            {message && (
                <Typography variant="h6" sx={{ mt: 2 }}>
                    {message}
                </Typography>
            )}
            {timeoutReached && (

                <Button
                    variant="contained"
                    color="secondary"
                    sx={{ mt: 2 }}
                    onClick={() => window.location.reload()}
                >
                    <FormattedMessage id="Reload the page" defaultMessage="Reload the page"/>
                </Button>
            )}
        </Backdrop>
    );
};

export default Loader;
